/**
 * useMcCatalog — master-class catalog for the OO МК block (B.12-R8.6).
 * GET /api/master-classes → {id, name, duration, branchId}. Loaded once.
 * A41 (PRC-4): branchId "" — сентинел общесетевой услуги; потребитель
 * (OoAssignScreen branchCat) уже трактует пустой branchId как «виден в
 * любом филиале» — фильтр не менять.
 */
import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { ApiList } from "../api/types";

export interface McItem {
  id: string;
  name: string;
  duration: number;
  branchId: string;
}

interface RawMc { id: string; name: string; duration?: number; branch_id?: string; active?: number }

export function useMcCatalog(reloadKey = 0): McItem[] {
  const [items, setItems] = useState<McItem[]>([]);
  useEffect(() => {
    let alive = true;
    api<ApiList<RawMc>>("/api/master-classes")
      .then((r) => {
        if (!alive) return;
        setItems((r.results ?? [])
          .filter((m) => m.active !== 0)
          .map((m) => ({ id: String(m.id), name: m.name, duration: Number(m.duration ?? 0), branchId: m.branch_id ?? "" })));
      })
      .catch(() => {});
    return () => { alive = false; };
    /* 31.08: reloadKey — «Обновить расстановку» перечитывает и каталог услуг
       (раньше правки EO не доезжали до МК-блока до пересоздания экрана). */
  }, [reloadKey]);
  return items;
}
